module.exports = __webpack_public_path__ + "static/media/backgrounds-pattern.3ff19ce1.svg";